import React from 'react';
import alexImage from '../../assets/images/alex.png'; // Profile photo
import './Aboutus.css';

function Aboutus() {
  return (
    <div className="aboutus-container">
      <div className="container">
        {/* About Us Title */}
        <h2 className="aboutus-title text-center">About Us</h2>

        {/* Row Container for Text and Image */}
        <div className="row align-items-center">
          {/* Left Text Section */}
          <div className="col-12 col-md-9">
            <p>
              We are a team of seasoned software professionals with industrial
              experience led by <strong>Mr. Alexander Jesudasan</strong>, a dedicated
              computer system engineer with over <strong>30 years</strong> of experience 
               in India and overseas. We are committed to provide training for
              selective group of <strong>indigent youngsters</strong> on
              their overall development that includes IT and Soft skills. 
              Our focus areas include:
            </p>

            <ul>
              <li>
                Train young graduates to become industry-ready IT professionals
                meeting the current industry requirements.
              </li>
              <li>
               Upskill the primitive skills for IT professionals
                to scale greater heights.
              </li>
              <li>
                Enable IT professionals to switch to thier interested area of Domain
              </li>
            </ul>

            <p>
              This endeavor started in <strong>Year 2021</strong> and has successfully trained
              candidates in different technologies.
            </p>

            <p>
              <strong>Highlights:</strong>
            </p>
            <ul>
              <li>30+ years of IT Industry experience in different software technologies.</li>
              <li>3+ years of experience on IT skills training for industry readiness.</li>
              <li>Successful history of placement assistance.</li>
            </ul>
          </div>
        
          {/* Right Image Section */}
          <div className="col-12 col-md-3 text-center">
            <img
              className="alex-image img-fluid"
              src={alexImage}
              alt="Alexander Jesudasan"
            />
          </div>
        </div>

        <p>
              <strong>Our Unique Offering : </strong>
              <strong className='pstrong'>What do they say : </strong>
            </p>
        {/* Row for Video Embeds */}
        <div className="row">
          {/* <div className="col-12 col-md-4 mb-3">
            
          </div> */}
          <div className=" abyoutb col-12 col-md-4 mb-3">
          <iframe width="450" height="315" src="https://www.youtube.com/embed/pd-42bys1WY" 
          title="RHEL 9 Installation on Virtual Machine" frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; 
          gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" 
          allowfullscreen></iframe>
          </div>
          <div className=" abyoutb1 col-12 col-md-4 mb-3">
          <iframe width="450" height="315" src="https://www.youtube.com/embed/91S5t1jrF5g" 
          title="nelson testimonial" frameborder="0" allow="accelerometer; autoplay; clipboard-write;
          encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aboutus;
